<template>
  <UContainer>
    <ReviewsBlock
      :items="reviews"
      :total-rating="pageData?.rating"
      :amount="reviews.length"
      title="Оставить отзыв о школе"
      :api-method="schoolStore.storeReview"
      :pending="pending"
    />
  </UContainer>
</template>

<script lang="ts" setup>
import ReviewsBlock from '~/components/ReviewsBlock.vue'

defineOptions({
  name: 'SchoolDetailReviews',
})

const { routeId } = useRouteId()

const schoolStore = useSchoolStore()
const { pageData, reviews } = storeToRefs(schoolStore)

const { pending } = await useAppAsyncData(
  `school-${routeId}-reviews`,
  async () => {
    await schoolStore.fetchReviews(routeId as string)
  },
)
</script>
